































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Gasequipment from "../../../store/entities/gasequipment";
@Component
export default class EditGasequipments extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  gasequipment: Gasequipment = new Gasequipment();
  updateInt:number=0;
  updateG:number=0;
  displaynone = "";
  updateIntervals=false;
  gflist=[];
  seltime=[
    {value: 1,label: '1分钟'},
    {value: 5,label: '5分钟'},
    {value: 10,label: '10分钟'},
    {value: 15,label: '15分钟'},
    {value: 30,label: '30分钟'},
    {value: 60,label: '60分钟'},
    {value: 120,label: '120分钟'},
    {value: 240,label: '240分钟'},
    {value: 360,label: '360分钟'},
    {value: 720,label: '720分钟'},
    {value: 1440,label: '1440分钟'},
  ]
  // gastype=[
  //   {value: 1,label: '氧气'},
  //   {value: 2,label: '二氧化碳'},
  //   {value: 3,label: '氮气'},
  //   {value: 4,label: '磷化氢'},
  // ]
  Isoxygen=false;
  Iscarbondioxide=false;
  Isnitrogen=false;
  Ischlorinehydride=false;
  Iscarbonicoxide=false;
  seltypelist=[];
  save() {
    (this.$refs.gasequipmentForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if(this.updateIntervals==true){
          this.gasequipment.updateInterval=1;
        }else{
          this.gasequipment.updateInterval=0;
        }
           if (this.Isoxygen == true) {
          this.gasequipment.Isoxygen = 1;
        } else {
          this.gasequipment.Isoxygen = 0;
        }
         if (this.Iscarbondioxide == true) {
          this.gasequipment.Iscarbondioxide = 1;
        } else {
          this.gasequipment.Iscarbondioxide = 0;
        }
         if (this.Isnitrogen == true) {
          this.gasequipment.Isnitrogen = 1;
        } else {
          this.gasequipment.Isnitrogen = 0;
        }
         if (this.Ischlorinehydride == true) {
          this.gasequipment.Ischlorinehydride = 1;
        } else {
          this.gasequipment.Ischlorinehydride = 0;
        }
         if (this.Iscarbonicoxide == true) {
          this.gasequipment.Iscarbonicoxide = 1;
        } else {
          this.gasequipment.Iscarbonicoxide = 0;
        }
        await this.$store.dispatch({
          type: "gasequipment/update",
          data: this.gasequipment,
        });
        (this.$refs.gasequipmentForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
   get floor() {
    return this.$store.state.floor.filterlist;
  }
  get gwequipment() {
    return this.$store.state.gwequipment.list;
  }
    get gasthreshold() {
    return this.$store.state.gasthreshold.list;
  }
  selfactory(value:Number){
    this.gasequipment.ftId = value;
    this.getwarehouse();
      this.getfloor();
  }
  selwarehouse(value:Number){
    this.gasequipment.wId = value;
    this.getfloor();
  }
  selfloor(value:Number){
    this.gasequipment.fId = value;
  }
  seltype(value:Number){
this.gasequipment.gId = value;
  }
  selEth(){
    this.displaynone="display:none";

  }
  selth(){
    this.displaynone = "";
  }
  
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getfilter",
      data: this.gasequipment,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getfilter",
      data: this.gasequipment,
    });
  }
  cancel() {
    (this.$refs.gasequipmentForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.gasequipment = Util.extend(true, {}, this.$store.state.gasequipment.editGasequipment);
     
      if(this.gasequipment.updateInterval==1){
        this.updateIntervals=true;
      }else{
        this.updateIntervals=false;
      }
       if(this.gasequipment.isoxygen==1){
        this.Isoxygen=true;
      }else{
        this.Isoxygen=false;
      }
       if(this.gasequipment.iscarbondioxide==1){
        this.Iscarbondioxide=true;
      }else{
        this.Iscarbondioxide=false;
      }
       if(this.gasequipment.isnitrogen==1){
        this.Isnitrogen=true;
      }else{
        this.Isnitrogen=false;
      }
       if(this.gasequipment.ischlorinehydride==1){
        this.Ischlorinehydride=true;
      }else{
        this.Ischlorinehydride=false;
      }
      if(this.gasequipment.iscarbonicoxide==1){
        this.Iscarbonicoxide=true;
      }else{
        this.Iscarbonicoxide=false;
      }
      this.selfactory(this.gasequipment.ftId);
      this.selwarehouse(this.gasequipment.wId);
      this.selfloor(this.gasequipment.fId);
    }
  }
   gasequipmentRule = {
     ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    snid: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    // number: [{transform: (value) => String(value), required: true, message: "请填写位置编号", trigger: "blur" }],
    gId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
    gas_type:[{ type:"number",required: true, message: "请选择气体类型", trigger: "change" }],
    acquisitionInterval: [{type:'number',required: true, message: "请选择采集间隔", trigger: "change" }],
    // gId:[{type:"number",required:true,message:"请选择网关",trigger:"change"}]
  };
}
